import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { RequestHeaders } from '@/common/constants';
import { API_URL } from '@/dtos';

import { TaxType } from '../../Contributions/contributions.types';

interface PayloadData {
  record_id?: number;
  ee_amount?: number;
  er_amount?: number;
  date?: string;
  tax_year?: string;
  tax_type?: TaxType;
  memo?: string;
  disabled?: boolean;
}

export const useUpdateContributionRecordsQuery = (
  requestId?: string,
  requestVersion?: number,
  onSuccess?: () => void,
  onError?: (errorText?: string) => void
) => {
  const { mutateAsync, isLoading, isSuccess } = useMutation(
    async (data?: PayloadData[]) =>
      api.put(
        API_URL.CONTRIBUTIONS_CONTRIBUTION_REQUESTS_CONTRIBUTION_RECORDS_BY_REQUEST_ID(requestId || ''),
        data,
        {
          headers: {
            [RequestHeaders.ifMatch]: requestVersion,
          },
        }
      ),
    {
      onSuccess: () => {
        if (onSuccess) onSuccess();
      },
      /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
      onError: (error: any) => {
        onError?.(error?.response?.data?.elevate_error_message);
      },
    }
  );

  return {
    updateContributionRecords: mutateAsync,
    isLoading,
    isSuccess,
  };
};
